/**
 * Widget for Toggling CA UI Kit Button State
 * Examples:
 * Default state: $(buttonSelector).buttonState('default')
 * Loading state: $(buttonSelector).buttonState('loading')
 */
(function($) {
  $.widget('caUi.buttonState', {
    options: {
      buttonText: '',
      loadingIcon: '<i class="ca-ui-i ca-ui-i-sync-alt ca-ui-i-spin"></i>'
    },

    _create: function() {
      if (!this.options.buttonText) {
        this.options.buttonText = this.element[0].textContent;
      }
    },

    default: function() {
      this.element.html(this.options.buttonText);
      this.element.prop('disabled', false);
    },

    loading: function() {
      this.element.html(this.options.loadingIcon);
      this.element.prop('disabled', true);
    }
  });
})(jQuery);
